<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="specialApplications">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.editPage.open(0)">
            新建
          </el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="编号">
              <el-input v-model.trim="filter.billNo" clearable/>
            </vm-search>
            <vm-search label="关联单号">
              <el-input v-model.trim="filter.factorNo" clearable/>
            </vm-search>
            <vm-search label="特批来源">
              <el-select v-model.trim="filter.applyType" clearable placeholder="请选择">
                <el-option
                    v-for="item in constant.toSelect(constant.specialApplicationType)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </vm-search>
            <vm-search label="物料名称">
              <el-input v-model.trim="filter.materialName" clearable/>
            </vm-search>
            <vm-search label="物料编号">
              <el-input v-model.trim="filter.materialNo" clearable/>
            </vm-search>
            <vm-search label="关联单号">
              <el-input v-model.trim="filter.relevanceNo" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" align="center" width="55"/>
        <el-table-column
            fixed="left"
            prop="billNo"
            width="120"
            align="center"
            label="特批单号">
          <template slot-scope="scope">
            <div style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="applyType" align="center" label="特批来源">
          <template slot-scope="scope">
            {{constant.specialApplicationType[scope.row.applyType]}}
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" align="center" label="申请人"/>
        <el-table-column prop="materialName" align="center" label="物料名称"/>
        <el-table-column prop="materialNo" align="center" label="物料名称"/>
        <el-table-column prop="factorNo" align="center" label="出厂编号"/>
        <el-table-column prop="creatorName" align="center" label="创建人"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button type="primary" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>
            <el-button v-if="scope.row.status===0" type="primary" @click="submit(scope.row.pkid)">提交</el-button>
            <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
      <special-application-edit ref="editPage" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import SpecialApplicationEdit from "@/views/purchase/SpecialApplication/SpecialApplicationEdit";

  export default {
    name: "",
    components: {SpecialApplicationEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        // addAuth: this.$auth(252),
        // editAuth: this.$auth(253),
        // delAuth: this.$auth(254),
        ids: [],
        filter: {
          billNo: "",
          factorNo:"",
          applyType:"",
          materialName: "",
          materialNo: "",
          relevanceNo: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","specialApplications",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      select(selection) {
        this.ids = [];
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "specialApplications/submit/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      goto(row) {
        this.$router.push({
          path: "/SpecialApplication",
          query: {
            billType: 30,
            billId: row.pkid,
            $tabName: row.billNo,
          },
        });
      },
    },
  };
</script>
<style scoped>
</style>
